const MAINTENANCE_MODE_KEY = 'kindbody-maintenance-mode';

export const setMaintenanceMode = (isActive: boolean): void => {
  if (isActive) {
    sessionStorage.setItem(MAINTENANCE_MODE_KEY, 'true');
  } else {
    sessionStorage.removeItem(MAINTENANCE_MODE_KEY);
  }
};

export const isMaintenanceModeActive = (): boolean => {
  return sessionStorage.getItem(MAINTENANCE_MODE_KEY) === 'true';
};

export const clearMaintenanceMode = (): void => {
  sessionStorage.removeItem(MAINTENANCE_MODE_KEY);
};
